import React, { Select } from 'react';
import TablaComprobantesDelegado from '../utils/TablaComprobantesDelegado';
import { useNotification } from '../utils/NotificationProvider';

const ComprobantesDelegadoLayer = () => {

    //const { notify } = useNotification();

    return (
        <>


            {/* 
            <div style={{ padding: "20px" }}>
                <button onClick={() => notify("Operación exitosa 🎉", "success")}>
                    Mostrar Éxito
                </button>
                <button
                    onClick={() => notify("Ocurrió un error 😢", "error")}
                    style={{ marginLeft: "10px" }}
                >
                    Mostrar Error
                </button>
                <button
                    onClick={() => notify("Atención ⚠️", "warning")}
                    style={{ marginLeft: "10px" }}
                >
                    Mostrar Advertencia
                </button>
                <button
                    onClick={() => notify("Mensaje informativo ℹ️", "info")}
                    style={{ marginLeft: "10px" }}
                >
                    Mostrar Info
                </button>
            </div>
              */}





            <TablaComprobantesDelegado />
        </>
    );
};

export default ComprobantesDelegadoLayer;